/** @jsx jsx */
import { Box, jsx } from "theme-ui";
import React from "react";

export const CompanyLogo: React.FC = ({}) => {
  return (
    <Box variant={"header.logo"}>
      <span sx={{ fontWeight: "bold" }}>Airport</span>
      <span>Link</span>
    </Box>
  );
};

export default CompanyLogo;

/* const query = graphql`
  query PageHeaderQuery {
    wp {
      rockitwebSettings {
        pageHeaderSettings {
          ...PageHeader
        }
      }
    }
  }
`; */
